// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"541":"da458701","627":"425a1fef"}[chunkId] || chunkId) + "." + {"541":"f47b4230a95c8803","627":"d61a61847ada9ef3","2182":"6d0c82b1fc4bc12f","3018":"ab75c57f16083e76","9119":"f55d162f0a4ccd2e"}[chunkId] + ".js";
};